<template>
    <div>
        <table border="1" class="trade-table" id="quotes" style="font-size: 1rem">
            <tr style="background-color: darkslategrey; color: white; padding: 3px; font-size: 1rem">
                <th style="text-align: center;">ticker</th>
                <th colspan=2 style="text-align: center;">{{ sameUnitsAndUnitMoves ? "open" : "open equity" }}</th>
                <th colspan=2 style="text-align: center;">{{ sameUnitsAndUnitMoves ? "close" : "close equity" }}</th>
                <th v-if="sameUnitsAndUnitMoves" style="text-align: center;">change</th>
                <th style="text-align: center;">equity change</th>
                <th style="text-align: center;">days</th>
                <th style="text-align: center;">avgerage profit/day</th>
                <th colspan=2 style="text-align: center;">max adverse excursion</th>
                <th colspan=2 style="text-align: center;">max profitable excursion</th>
            </tr>
            <tr v-for="n in trades" v-bind:key="n.index" style="text-align: right; font-weight: normal">
                <td style="white-space: nowrap; padding: 2px; text-align: center">{{n.spread}}</td>
                <td style="white-space: nowrap; padding: 2px">{{n.openDate}}</td>
                <td v-if="sameUnitsAndUnitMoves" style="white-space: nowrap; padding: 2px">{{n.open}}</td>
                <td v-if="!sameUnitsAndUnitMoves" style="white-space: nowrap; padding: 2px">{{displayMoneyFormat(n.openEquity)}}</td>
                <td style="white-space: nowrap; padding: 2px">{{n.closeDate}}</td>
                <td v-if="sameUnitsAndUnitMoves" style="white-space: nowrap; padding: 2px">{{n.close}}</td>
                <td v-if="!sameUnitsAndUnitMoves" style="white-space: nowrap; padding: 2px">{{displayMoneyFormat(n.closeEquity)}}</td>
                <td v-if="sameUnitsAndUnitMoves" v-bind:style="{color: n.change < 0 ? 'red' : 'black' }" style="white-space: nowrap; padding: 2px">{{n.change}}</td>
                <td v-bind:style="{color: n.change < 0 ? 'red' : 'black' }" style="white-space: nowrap; padding: 2px">{{displayMoneyFormat(n.equityChange)}}</td>

                <td style="white-space: nowrap; padding: 2px">{{n.days}}</td>
                <td  v-bind:style="{color: n.appd < 0 ? 'red' : 'black' }" style="white-space: nowrap; padding: 2px">{{displayMoneyFormat(n.appd)}}</td>

                <td style="white-space: nowrap; padding: 2px">{{n.minDate}}</td>
                <td v-bind:style="{color: n.min < 0 ? 'red' : 'black' }" style="white-space: nowrap; padding: 2px">{{displayMoneyFormat(n.min)}}</td>
                <td style="white-space: nowrap; padding: 2px">{{n.maxDate}}</td>
                <td style="white-space: nowrap; padding: 2px; color: black">{{displayMoneyFormat(n.max)}}</td>
            </tr>
            <tr style="font-weight: bold; text-align: right; white-space: nowrap; font-size: 1rem">
                <td colspan="3" style="text-align: center">{{numberOfTrades}} trades:  &nbsp;&nbsp; {{percentUp}}% profitable</td>
                <td colspan="2" style="text-align: right; padding-right: 2px;">averages:</td>
                <td v-if="sameUnitsAndUnitMoves" v-bind:style="{color: avgChange < 0 ? 'red' : 'black' }" style="padding-right: 2px;">{{avgChange}}</td>
                <td v-bind:style="{color: avgChange < 0 ? 'red' : 'black' }" style="padding-right: 2px;">{{displayMoneyFormat(avgEquityChange)}}</td>
                <td style="padding-right: 2px;">{{avgDays}}</td>
                <td v-bind:style="{color: avgChange < 0 ? 'red' : 'black' }" style="padding-right: 2px;">{{displayMoneyFormat(avgAppd)}}</td>

                <td colspan="2" style="color: red; padding-right: 2px;">{{displayMoneyFormat(avgMin)}}</td>
                <td colspan="2" style="color: black; padding-right: 2px;">{{displayMoneyFormat(avgMax)}}</td>
            </tr>
        </table>    
    </div>
</template>

<script>

    import $ from "jquery";
    import {contractNameDecomposer, spreadTitle} from "../js/main";
    import moment from 'moment';
    import {getCommoditiesObject} from '../js/main';

    export default {
        mounted: function () {
            // this.loadParsedData();
        },
        props: {
            namespace: {
                type: String,
                default: ""
            },
            parsedData: {
                type: Object
            }
        },
        data: function () {
            return {
                sameUnitsAndUnitMoves: true,
                trades: [],
                upNumber: 0,
                numberOfTrades: 0,
                percentUp: 0,
                percentDown: 0,
                avgChange: 0,
                avgEquityChange: 0,
                avgMax: 0,
                avgMin: 0,
                avgDays: 0,
                avgAppd: 0,
                busy: false
            }
        },
        watch: {
            parsedData: function (parsedData) {
                console.log("watch parsedData = ", JSON.parse(JSON.stringify(parsedData)));
                //let generalForm = JSON.parse(JSON.stringify(this.$store.state[this.namespace]));
                if (typeof parsedData.values === 'undefined' || parsedData.values === null) {
                    this.parsedData.values = [];
                }
                this.loadParsedData();
            },
            loading: function (loading) {
                // console.log("loading watch!");
                if (loading) {
                    document.getElementById(this.namespace).innerHTML = "";
                }
            }
        },
        methods: {
            customToFixed: function (number) {
                // console.log("number=", number);
                var returnValue;
                if (isNaN(number) || null == number) {
                    // console.log("missing data.");
                    returnValue = "\u00A0\u00A0------\u00A0\u00A0 ";
                } else {
                    returnValue = number.toFixed(this.digits);
                }
                // console.log("returnValue=", returnValue);
                return returnValue;
            },
            displayMoneyFormat: function (number) {
                // console.log("number=", number);
                var returnValue;
                if (isNaN(number) || null == number) {
                    // console.log("missing data.");
                    returnValue = "------\u00A0\u00A0\u00A0 ";
                } else {
                    returnValue = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD'
                    }).format(number);
                }
                // console.log("returnValue=", returnValue);
                return returnValue;
            },
            loadParsedData() {
                if (typeof this.parsedData.unit === 'undefined' && Object.keys(this.parsedData.values).length !== 0) {
                    this.trades = [];
                    this.numberOfTrades = 0;
                    this.upNumber = 0;
                    this.percentUp = 0;
                    this.avgChange = 0;
                    this.avgEquityChange = 0;
                    this.avgMin = 0;
                    this.avgMax = 0;
                    this.avgDays = 0;
                    this.avgAppd = 0;

                    this.digits = this.parsedData.digits;
                    this.sameUnitsAndUnitMoves = this.parsedData.sameUnitsAndUnitMoves;

                    $('#unauthorized').empty();
                    var temp = this.parsedData.values;
                    console.log("temp=", temp);
                    if (typeof temp !== 'undefined' && temp !== null) {
                        Object.keys(temp).forEach(function (key) {
                            if (Array.isArray(temp[key])) {
                                // console.log("temp[", key, "]=", temp[key]);
                                temp[key] = temp[key].reverse();
                            }
                        });

                        var numberOfRows = temp.spreads.length;
                        var contract = temp.spreads[0].split("/");
                        // console.log("contract=", contract + " contract.length=", contract.length);
                        var commodity = contractNameDecomposer(contract[0].trim()).commoditySymbol;
                        var unitMove = 1;
                        if (this.sameUnitsAndUnitMoves) {
                            unitMove = getCommoditiesObject()[commodity].unitMove;
                        }

                        var tempForm = JSON.parse(JSON.stringify(this.$store.state[this.namespace]));

                        let invertDatesMultiplier = this.$store.state[this.namespace].browserSideOnly.invertDatesMultiplier;
                        console.log("invertDatesMultiplier=", invertDatesMultiplier);

                        for (let i = 0; i < numberOfRows; i++) {
                            tempForm.selected[0] = temp.spreads[i].trim();
                            // tempForm.rsiSource = temp.spreads[i].trim();

                            var row = {};
                            var title = spreadTitle(tempForm);
                            if (title[0] === '-' && contract.length == 1) {
                                title = title.substr(1);
                            }
                            row.spread = title;

                            let open = this.customToFixed(temp.openVector[i]);
                            row.open = isNaN(open) ? open : invertDatesMultiplier * open;
                            row.openEquity = unitMove * row.open;
                            let openDate = moment(temp.openDateVector[i], "YYYYMMDD");
                            row.openDate = isNaN(open) ? "\u00A0\u00A0----------\u00A0\u00A0 " : openDate.format("MMM D, YYYY");

                            let close = this.customToFixed(temp.closeVector[i]);
                            row.close = isNaN(close) ? close : invertDatesMultiplier * close;
                            row.closeEquity = unitMove * row.close;
                            let closeDate = moment(temp.closeDateVector[i], "YYYYMMDD");
                            row.closeDate = isNaN(close) ? "\u00A0\u00A0----------\u00A0\u00A0 " : closeDate.format("MMM D, YYYY");

                            if (closeDate.isAfter(openDate)) {
                                row.change = this.customToFixed(temp.changeVector[i]);
                                row.equityChange = unitMove * this.customToFixed(temp.changeVector[i]);

                                let minDate = temp.minDateVector[i];
                                row.minDate = minDate === null ? "\u00A0\u00A0----------\u00A0\u00A0 " : moment(minDate, "YYYYMMDD").format("MMM D, YYYY");
                                row.min = unitMove * this.customToFixed(temp.minVector[i]);

                                let maxDate = temp.maxDateVector[i];
                                row.maxDate = maxDate === null ? "\u00A0\u00A0----------\u00A0\u00A0 " : moment(maxDate, "YYYYMMDD").format("MMM D, YYYY");
                                row.max = unitMove * this.customToFixed(temp.maxVector[i]);

                                let days = temp.daysVector[i];
                                row.days = days === null ? "\u00A0\u00A0------\u00A0\u00A0 " : days;

                                let appd = unitMove * /*this.customToFixed(*/temp.appdVector[i]/*)*/;
                                row.appd = isNaN(appd) ? appd : invertDatesMultiplier * appd;
                            } else {
                                row.openDate = "\u00A0\u00A0----------\u00A0\u00A0 ";
                                row.closeDate = "\u00A0\u00A0----------\u00A0\u00A0 ";
                                row.open = "\u00A0\u00A0------\u00A0\u00A0 ";
                                row.close = "\u00A0\u00A0------\u00A0\u00A0 ";
                                row.change = "\u00A0\u00A0------\u00A0\u00A0 ";
                                row.equityChange = "\u00A0\u00A0------\u00A0\u00A0 ";
                                row.minDate = "\u00A0\u00A0----------\u00A0\u00A0 ";
                                row.min = "\u00A0\u00A0----------\u00A0\u00A0 ";
                                row.maxDate = "\u00A0\u00A0----------\u00A0\u00A0 ";
                                row.max = "\u00A0\u00A0----------\u00A0\u00A0 ";
                                row.days = "\u00A0\u00A0----------\u00A0\u00A0 ";
                                row.appd = "\u00A0\u00A0----------\u00A0\u00A0 ";
                            }
                            this.trades.push(row);
                        }

                        var stats = this.parsedData.statsJson;
                        this.percentUp = stats.percentUp.toFixed(1);
                        this.avgChange = stats.avgChange.toFixed(1 + this.digits);
                        this.avgEquityChange = (unitMove * stats.avgChange).toFixed(2 + this.digits);
                        this.avgMax = unitMove * stats.avgMax.toFixed(3 + this.digits);
                        this.avgMin = unitMove * stats.avgMin.toFixed(3 + this.digits);
                        this.numberOfTrades = stats.numberOfTrades;
                        this.avgAppd = unitMove * stats.avgChange / stats.avgDays;
                        this.avgDays = stats.avgDays.toFixed(3);
                    }
                } else {
                    this.trades = [];
                    this.numberOfTrades = 0;
                    this.upNumber = 0;
                    this.percentUp = 0;
                    this.avgChange = 0;
                    this.avgEquityChange = 0;
                    this.avgMin = 0;
                    this.avgMax = 0;
                    this.avgDays = 0;
                    this.avgAppd = 0;
                    $('#unauthorized').html("<H3 style='color: red; text-align: left; margin-left: 7px'>" + this.parsedData.unit + "</H3>");
                    $("#progress").hide();
                   // $("#button").show();
                }
            }
        }

    }
</script>

<style>
    #quotes {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #quotes td, #quotes th {
        border: 1px solid #ddd;
        padding-right: 15px;
        padding-left: 15px;
    }

    #quotes tr:nth-child(even){background-color: #f2f2f2;}

    #quotes tr:hover {background-color: #ddd;}

    #quotes th {
        padding-top: 4px;
        padding-bottom: 4px;
        text-align: left;
        background-color: teal;
        color: white;
    }
</style>